<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">
        <required-tag v-if="required"></required-tag>
        <span>
        {{ label }}
        </span>
      </div>
    </el-col>
    <el-col :span="spanSetting">
      <el-input type="text"
                :value="text"
                v-on:change="$emit('commit', $event)"
                v-on:input="$emit('change', $event)"
                class="input-number">
      </el-input>
    </el-col>
    <el-col :span="spanSuffix">
      <div class="suffix-area">{{ suffix }}</div>
    </el-col>
  </el-row>
</template>

<script>
import RequiredTag from '@/components/RequiredTag.vue'
import Constants from './Constants'

export default {
  name: 'InputTextBox',
  components: {
    requiredTag: RequiredTag
  },
  model: {
    prop: 'text',
    event: 'change'
  },
  props: {
    text: {
      type: String
    },
    label: {
      type: String
    },
    suffix: {
      type: String
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    spanSuffix: {
      type: Number
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logging: function (val) {
      console.log(val)
    }
  }
}
</script>

<style>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
div.suffix-area {
  text-align: left;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
}
.input-number input.el-input__inner {
  font-size: large;
  text-align: right;
}
</style>
